import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-container" style={{ gridTemplateColumns: '1fr', maxWidth: 900, textAlign: 'center' }}>
          <div className="about-hero-content">
            <span className="section-label">Über mich</span>
            <h1 className="about-hero-title">
              Hi, ich bin <span className="gold">Niels</span> 👋
            </h1>
            <p className="about-hero-subtitle">
              Gründer von hoefner.agency
            </p>
            <p className="about-hero-text">
              Leidenschaft für Ästhetik, ein geschultes Auge fürs Detail und der Anspruch, 
              Marken wirklich sichtbar zu machen – genau dafür stehe ich.
            </p>
          </div>
        </div>
      </section>

      {/* My Story Section */}
      <section className="story-section">
        <div className="section-container">
          <div className="story-grid" style={{ gridTemplateColumns: '1fr', maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
            <div className="story-content">
              <span className="section-label">Meine Mission</span>
              <h2 className="story-title">Visionen werden zu starken Marken</h2>
              <p className="story-text">
                Ich helfe Unternehmen dabei, ihre Visionen in starke visuelle Identitäten zu verwandeln 
                und Social Media nicht nur „zu bespielen", sondern gezielt als Wachstumskanal zu nutzen.
              </p>
              <p className="story-text">
                In den letzten Monaten habe ich immer wieder dasselbe beobachtet: Viele Unternehmen haben 
                starke Leistungen, aber erreichen nicht die Ergebnisse, die sie sich wünschen.
              </p>
              <p className="story-text-emphasis">
                Nicht, weil sie nicht gut genug sind.<br />
                Sondern weil die <span className="gold">Strategie fehlt</span>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Problem & Solution */}
      <section className="problem-solution-section">
        <div className="section-container">
          <div className="ps-grid">
            <div className="problem-card">
              <h3 className="ps-title">Das Problem</h3>
              <ul className="problem-list">
                <li>
                  <span className="x-icon">✕</span>
                  <span>Kein klarer, strukturierter Plan</span>
                </li>
                <li>
                  <span className="x-icon">✕</span>
                  <span>Kein skalierbares System</span>
                </li>
                <li>
                  <span className="x-icon">✕</span>
                  <span>Kein Content, der Vertrauen aufbaut und verkauft</span>
                </li>
              </ul>
            </div>

            <div className="solution-card">
              <h3 className="ps-title gold">Meine Lösung</h3>
              <ul className="solution-list">
                <li>
                  <span className="check-icon">✓</span>
                  <span>Sichtbarkeit gezielt aufbauen</span>
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  <span>Vertrauen nachhaltig stärken</span>
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  <span>Über Social Media planbar Kunden gewinnen</span>
                </li>
              </ul>
            </div>
          </div>

          <p className="ps-summary">
            <span className="gold">Praxisnah. Strategisch.</span> Ohne unnötige Komplexität.
          </p>
        </div>
      </section>

      {/* Approach Section */}
      <section className="approach-section">
        <div className="section-container">
          <div className="approach-content">
            <span className="section-label">Mein Anspruch</span>
            <h2 className="approach-title">Mehr als nur Content – echte Wirkung</h2>
            <p className="approach-text">
              Von der ersten Idee bis zur finalen Umsetzung entsteht dabei mehr als nur Content – 
              <span className="gold"> es entsteht Wirkung.</span>
            </p>
            <p className="approach-text">
              Wenn du Social Media nicht länger dem Zufall überlassen willst, sondern als echten 
              Wachstumstreiber nutzen möchtest, dann bist du hier richtig.
            </p>
          </div>
        </div>
      </section>

      {/* Qualifications Section */}
      <section className="qualifications-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-label">Qualifikationen</span>
            <h2 className="section-title">Expertise auf höchstem Niveau</h2>
            <p className="section-description">
              Fundiertes Wissen kombiniert mit praktischer Erfahrung – die Basis für deinen Erfolg.
            </p>
          </div>

          <div className="qualification-card">
            <div className="qualification-badge">
              <div className="badge-circle">
                <span className="badge-text">MBA</span>
              </div>
            </div>
            <div className="qualification-info">
              <h3>Mini-MBA</h3>
              <p className="institution">International Business Management Institute, Berlin</p>
              <p className="qualification-description">
                Eine umfassende Management-Qualifikation, die strategisches Denken, Business-Expertise 
                und Marketing-Know-how auf höchstem Niveau vereint.
              </p>
              <div className="modules-grid">
                <div className="module-item">📊 International Business & Economics</div>
                <div className="module-item">🎯 Essential Management Skills</div>
                <div className="module-item">👥 Human Resource Management</div>
                <div className="module-item">📈 Strategy & Operations</div>
                <div className="module-item">💰 Finance & Accounting</div>
                <div className="module-item">📣 Marketing & Communications</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta-section">
        <div className="section-container">
          <div className="about-cta-content">
            <h2>Lass uns gemeinsam etwas Großes bewegen</h2>
            <p>Dein Erfolg ist mein Antrieb. Lass uns sprechen.</p>
            <Link to="/kontakt" className="btn-primary">
              Kostenloses Erstgespräch
              <span className="btn-arrow">→</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
